/** Builds the create-session body: at most one of wp_id / faicon_id, plus event_data naming the event. */
export const buildSessionPayload = ({ uploadId, title, description, source, link, transcribe, provider, language }) => {
  const payload = {
    upload_id: uploadId,
    title,
    description,
    auto_generate_transcript: transcribe,
  };
  if (transcribe) {
    payload.transcript_provider = provider;
    payload.transcription_language = language;
  }
  if (source === 'WordPress' && link.eventId) {
    payload.wp_id = link.eventId;
    if (link.sessionId) payload.wp_session_id = link.sessionId;
  } else if (source === 'Faicon' && link.eventId) {
    payload.faicon_id = link.eventId;
    if (link.sessionId) payload.faicon_session_id = link.sessionId;
  }
  payload.event_data = { title: (link.eventId && link.eventTitle) || title };
  if (description.trim()) payload.event_data.description = description;
  return payload;
};
